import { useEffect, useMemo } from 'react'

import { CartoAuthContext } from './context'
import { setGetToken } from './token'
import type { AuthProviderProps, CartoAuthContextValue } from './types'

export function AuthProvider({
  children,
  isAuthenticated,
  isLoading,
  error,
  user,
  loginWithRedirect,
  logout,
  getAccessTokenSilently
}: AuthProviderProps): JSX.Element {
  const value = useMemo<CartoAuthContextValue>(
    () => ({ isAuthenticated, isLoading, error, user, loginWithRedirect, logout, getAccessTokenSilently }),
    [isAuthenticated, isLoading, error, user, loginWithRedirect, logout, getAccessTokenSilently]
  )

  useEffect(() => {
    setGetToken(getAccessTokenSilently)
  }, [getAccessTokenSilently])

  return <CartoAuthContext.Provider value={value}>{children}</CartoAuthContext.Provider>
}
